import React from 'react';
import { Section } from './ui/Section';
import { Award, Briefcase, Users } from 'lucide-react';
export function About() {
  return <Section id="sobre-mi" className="bg-brand-dark" data-id="element-18">
      <div className="max-w-6xl mx-auto" data-id="element-19">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-20">
          {/* Left: Copy */}
          <div data-id="element-21">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-accent/10 border border-brand-accent/20 text-brand-accent text-sm font-medium mb-6" data-id="element-22">
              <Award className="w-4 h-4" data-id="element-23" />
              <span data-id="element-24">Fundador & Especialista</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-25">
              Quién Está Detrás de Esto
            </h2>

            <div className="space-y-6 text-lg text-slate-300" data-id="element-26">
              <p data-id="element-27">
                <strong className="text-white text-xl" data-id="element-28">
                  Me llamo Nacho Gomez.
                </strong>{' '}
                Soy el fundador de mi agencia de diseño web y marketing digital.
              </p>
              <p data-id="element-29">
                Llevo más de 3 años ayudando a emprendedores a
                transformar su presencia digital en su activo más poderoso — una
                web que no solo se ve profesional, sino que trabaja por ellos
                todos los días.
              </p>
              <p data-id="element-30">
                No llegué a esto estudiando teoría en un aula. Llegué aquí
                trabajando en las trincheras: construyendo páginas, analizando
                datos, ajustando estrategias y aprendiendo exactamente qué
                separa una web que convierte de una que solo ocupa espacio en
                internet.
              </p>
              <p className="font-medium text-white border-l-4 border-brand-accent pl-4 py-2 bg-brand-surface/30" data-id="element-31">
                No trabajo con cualquiera. Trabajo con emprendedores serios que
                están listos para dar el siguiente nivel.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 mt-10 pt-8 border-t border-white/10" data-id="element-32">
              <div data-id="element-33">
                <Users className="w-5 h-5 text-brand-accent mb-2" data-id="element-34" />
                <p className="text-2xl font-bold text-white" data-id="element-35">+1000</p>
                <p className="text-xs text-slate-400 leading-tight" data-id="element-36">
                  Emprendedores ayudados
                </p>
              </div>
              <div data-id="element-37">
                <Briefcase className="w-5 h-5 text-brand-accent mb-2" data-id="element-38" />
                <p className="text-2xl font-bold text-white" data-id="element-39">+3 Años</p>
                <p className="text-xs text-slate-400 leading-tight" data-id="element-40">
                  De experiencia
                </p>
              </div>
              <div data-id="element-41">
                <Award className="w-5 h-5 text-brand-accent mb-2" data-id="element-42" />
                <p className="text-2xl font-bold text-white" data-id="element-43">100%</p>
                <p className="text-xs text-slate-400 leading-tight" data-id="element-44">
                  Enfoque en resultados
                </p>
              </div>
            </div>
          </div>

          {/* Right: Portrait */}
          <div className="relative" data-id="element-45">
            {/* Glow */}
            <div className="absolute -inset-6 bg-brand-accent/20 blur-3xl rounded-full opacity-60 pointer-events-none" data-id="element-46" />

            <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl shadow-black/50 aspect-[3/4] max-w-md mx-auto lg:max-w-none" data-id="element-47">
              <img src="https://cdn.magicpatterns.com/uploads/hfcqaZzt1fXzxc649E7z3T/nano-banana-2_A_cinematic_portrait_photograph_of_Cinematic_hero_banner_16_9_aspect_ratio._A_co-1.jpg" alt="Nacho Gomez — Fundador y Especialista en Diseño Web Estratégico" className="w-full h-full object-cover" data-id="element-48" />

              {/* Subtle bottom gradient for caption legibility */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" data-id="element-49" />

              {/* Caption */}
              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-50">
                <div className="flex items-center gap-3" data-id="element-51">
                  <div className="w-1 h-10 bg-brand-accent rounded-full" data-id="element-52" />
                  <div data-id="element-53">
                    <h3 className="text-lg font-bold text-white leading-tight" data-id="element-54">
                      Nacho Gomez
                    </h3>
                    <p className="text-sm text-brand-accent" data-id="element-55">
                      Fundador · Diseño Web & Marketing Digital
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}